import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../contexts/AuthContext";
import { supabase } from "../../lib/supabase";
import { queryKeys } from "../../lib/queryKeys";
import { AgentConnection } from "../../types";

export async function fetchAgentConnections(): Promise<AgentConnection[]> {
  const { data, error } = await supabase
    .from("agent_connections")
    .select("id, user_id, name, scope, last_used_at, revoked_at, created_at")
    .is("revoked_at", null)
    .order("created_at", { ascending: false });
  if (error) throw error;
  return (data ?? []) as AgentConnection[];
}

export function useAgentConnections() {
  const { user } = useAuth();
  return useQuery({
    queryKey: queryKeys.agentConnections,
    queryFn: fetchAgentConnections,
    enabled: !!user,
  });
}
